import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ad46fd56&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ad46fd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad46fd56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad46fd56')) {
      api.createRecord('ad46fd56', component.options)
    } else {
      api.reload('ad46fd56', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ad46fd56&scoped=true&", function () {
      api.rerender('ad46fd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4WYqt2giWG0HR/JS/comp/PopupBox.vue"
export default component.exports